module.exports = __webpack_public_path__ + "img/dzblgl.2b7f4ba3.png";